import { useEffect, useRef, useState } from 'react';
import { AiOutlineSearch } from 'react-icons/ai';
import { BiChevronDown } from 'react-icons/bi';

const SearchSelector = (props: {
    label?: string;
    hideLabel?: boolean;
    options: any;
    displayKey: string;
    onSelect: any;
    value?: string | null;
    canCreate?: boolean;
    createNew?: any;
    disabled?: boolean;
    inputSmall?: boolean;
    defaultKey?: string;
    secondaryKey?: string;
    onMenuStateChange?: (isOpen: boolean) => void;
}) => {
    const {
        label,
        options,
        displayKey,
        onSelect,
        hideLabel,
        value,
        canCreate,
        createNew,
        disabled,
        inputSmall = false,
        defaultKey = '_id',
        secondaryKey = false,
        onMenuStateChange,
    } = props;

    const [inputValue, setInputValue] = useState('');
    const [selected, setSelected] = useState('');
    const [open, setOpen] = useState(false);
    const inputRef = useRef<HTMLInputElement>(null);
    const listRef = useRef<HTMLUListElement>(null); // Ref for the scrollable list

    useEffect(() => {
        console.log('SearchSelector options:', options?.length || 0, 'options');
    }, [options]);

    useEffect(() => {
        if (onMenuStateChange) {
            onMenuStateChange(open);
        }
    }, [open, onMenuStateChange]);

    useEffect(() => {
        if (value) {
            const defaultValue = options.find(
                (o: any) => o[defaultKey] === value,
            );
            if (defaultValue !== undefined)
                setSelected(defaultValue?.[displayKey]);
        }
    }, [value, options, displayKey, defaultKey]);

    const toggleDropdown = () => {
        if (disabled) return;
        setOpen((prev) => {
            const newOpenState = !prev;

            if (newOpenState) {
                // Focus the input and reset scroll position
                if (inputRef.current) inputRef.current.focus();
                if (listRef.current) listRef.current.scrollTop = 0;
            }

            return newOpenState;
        });
    };

    return (
        <div className="h-10 w-full font-medium gap-2 relative">
            <label
                htmlFor={hideLabel ? '' : label}
                className={`
                    ${
                        inputSmall
                            ? 'text-xs font-medium'
                            : 'text-sm font-medium'
                    }
                    text-navy-700 dark:text-white`}
            >
                {hideLabel ? '' : label}
            </label>
            <div
                onClick={toggleDropdown}
                className={`${
                    inputSmall && 'h-[35px]'
                } flex w-full items-center justify-between rounded-xl border ${
                    disabled ? 'bg-gray-100' : 'bg-white bg-white/0'
                } p-3 text-sm outline-none ${
                    !selected && 'text-sm text-gray-300'
                }`}
            >
                {selected
                    ? selected?.length > 25
                        ? selected?.substring(0, 25) + '...'
                        : selected
                    : `Sélectionner`}
                <BiChevronDown
                    size={20}
                    className={`${open && 'rotate-180'}`}
                />
            </div>
            <ul
                ref={listRef}
                className={`absolute mt-2 overflow-y-auto rounded-xl bg-white shadow-lg z-[200] w-full ${
                    open ? 'max-h-60 border' : 'max-h-0'
                } `}
            >
                <div className="sticky top-0 flex items-center bg-white px-2">
                    <AiOutlineSearch size={18} className="text-gray-700" />
                    <input
                        ref={inputRef}
                        type="text"
                        value={inputValue}
                        onChange={(e) =>
                            setInputValue(e.target.value.toLowerCase())
                        }
                        placeholder={`Recherche...`}
                        autoFocus={false}
                        className="w-[80%] p-2 text-sm outline-none placeholder:text-gray-700"
                    />
                    {canCreate && (
                        <button
                            className="ml-10 hidden text-xs outline-none placeholder:text-gray-700 lg:block"
                            onClick={createNew}
                        >
                            Ajouter
                        </button>
                    )}
                </div>
                {options?.map((option: any, index: number) => (
                    <li
                        key={`${option?.[displayKey]}-${index}`}
                        className={`sticky p-2 text-xs hover:bg-gray-100
              ${
                  option?.name?.toLowerCase() === selected?.toLowerCase()
                      ? 'bg-gray-100'
                      : 'bg-white'
              }
              ${
                  option?.[displayKey]
                      ?.toLowerCase()
                      .includes(inputValue?.toLowerCase()) ||
                  (secondaryKey &&
                      option?.[secondaryKey]
                          ?.toString()
                          ?.toLowerCase()
                          .includes(inputValue?.toLowerCase()))
                      ? 'block'
                      : 'hidden'
              }`}
                        onClick={() => {
                            if (
                                option?.[displayKey]?.toLowerCase() !==
                                selected.toLowerCase()
                            ) {
                                setSelected(option?.[displayKey]);
                                onSelect(option);
                                setOpen(false);
                                setInputValue('');
                            }
                        }}
                    >
                        {option?.[displayKey]}
                    </li>
                ))}
                {options?.length === 0 && (
                    <li className="p-2 text-xs animate-pulse">Chargement...</li>
                )}
            </ul>
        </div>
    );
};

export default SearchSelector;
